export default __webpack_public_path__ + "689575ff4d8e5e6d39e6cf63d9ff1456.woff";